import { METHOD } from './method'

export const API_BEAUTY_PROFILE = {
    LIST: {
        api: '/v1/dashboard-admin/general-setting/beauty-profile/list',
        method: METHOD.POST,
    },
    DELETE: {
        api: '/v1/dashboard-admin/general-setting/beauty-profile',
        method: METHOD.DELETE,
    },
    URL_BEAUTY_PROFILE_IMAGES: {
        api: '/v1/dashboard-admin/general-setting/beauty-profile/storage-url/attachment',
        method: METHOD.POST,
    },
    CREATE: {
        api: '/v1/dashboard-admin/general-setting/beauty-profile',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/general-setting/beauty-profile',
        method: METHOD.PUT,
    },
    DETAIL: {
        api: '/v1/dashboard-admin/general-setting/beauty-profile',
        method: METHOD.GET,
    },
}
